// extracted by mini-css-extract-plugin
export default {"alertBarContainer":"BU9VBN_ni2"};